module.exports = __webpack_public_path__ + "static/img/develop1.8e34e86f.png";